import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white border-b border-gray-300" }
const _hoisted_2 = { class: "flex justify-between w-full p-6 mx-auto max-w-screen-xl" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "ml-6" }
const _hoisted_5 = {
  class: "text-lg font-bold text-gray-900",
  "data-cy": "nav-patient-name"
}
const _hoisted_6 = { class: "uppercase" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  class: "text-base font-semibold uppercase text-gray-400",
  "data-cy": "nav-patient-id"
}
const _hoisted_9 = {
  key: 0,
  class: "pl-2"
}
const _hoisted_10 = { class: "grid gap-x-8 grid-rows-2 grid-flow-col" }
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = { class: "text-gray-500 mr-3" }
const _hoisted_13 = {
  class: "font-medium",
  "data-cy": "nav-patient-dob"
}
const _hoisted_14 = { class: "flex justify-between" }
const _hoisted_15 = { class: "text-gray-500 mr-3" }
const _hoisted_16 = {
  class: "font-medium",
  "data-cy": "nav-patient-age"
}
const _hoisted_17 = { class: "flex justify-between" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "text-gray-500 mr-3" }
const _hoisted_20 = {
  class: "font-medium",
  "data-cy": "nav-patient-sex"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "text-gray-500 mr-3" }
const _hoisted_23 = {
  class: "font-medium",
  "data-cy": "nav-patient-sex"
}
const _hoisted_24 = { class: "flex justify-between" }
const _hoisted_25 = { class: "text-gray-500 mr-3" }
const _hoisted_26 = {
  class: "font-medium",
  "data-cy": "nav-patient-ethnicity"
}
const _hoisted_27 = { class: "flex justify-between" }
const _hoisted_28 = { class: "text-gray-500 mr-3" }
const _hoisted_29 = {
  class: "font-medium",
  "data-cy": "nav-patient-phone"
}
const _hoisted_30 = {
  key: 0,
  class: "flex justify-between items-center"
}
const _hoisted_31 = {
  class: "font-medium uppercase",
  "data-cy": "nav-patient-mrn"
}
const _hoisted_32 = { class: "border-t" }
const _hoisted_33 = { class: "flex w-full h-16 mx-auto max-w-screen-xl" }
const _hoisted_34 = { class: "flex flex-grow" }
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-gray-500" }, "Clinical Blocks Demonstration", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_ButtonLink = _resolveComponent("ButtonLink")!
  const _component_MkBadge = _resolveComponent("MkBadge")!
  const _component_NavLink = _resolveComponent("NavLink")!
  const _component_NavDropdownButton = _resolveComponent("NavDropdownButton")!
  const _component_PopoverLink = _resolveComponent("PopoverLink")!
  const _component_BasePopover = _resolveComponent("BasePopover")!
  const _component_BaseBanner = _resolveComponent("BaseBanner")!
  const _directive_allow = _resolveDirective("allow")!
  const _directive_feature_flagged = _resolveDirective("feature-flagged")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ButtonLink, {
          to: "/patients",
          color: "primary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_BaseIcon, {
              name: "arrow-left",
              class: "text-lg text-white stroke-1.5"
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.patient.last_name), 1),
            _createTextVNode(", " + _toDisplayString(_ctx.patient.first_name) + " ", 1),
            (_ctx.patient.deceased_at)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('custom.uhb.patient.deceased-title')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", null, "ID: " + _toDisplayString(_ctx.patient.mrn), 1),
            (_ctx.patient.minor_patients && _ctx.patient.minor_patients.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createVNode(_component_MkBadge, {
                    color: "primary",
                    size: "xsmall",
                    class: "capitalize"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('custom.uhb.patient.major-indicator')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('platform.patient.dob')), 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formatDate(_ctx.patient.date_of_birth)), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('platform.patient.age')), 1),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('platform.patient.years', { age: _ctx.patient.age })), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_ctx.useGender)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('platform.patient.gender')), 1),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.gender && _ctx.gender.label), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('platform.patient.sex')), 1),
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.sex && _ctx.sex.label), 1)
              ]))
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('platform.patient.ethnicity')), 1),
          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.patient.ethnicity ? _ctx.patient.ethnicity.title : _ctx.$t('platform.patient.not-specified')), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('platform.patient.phone')), 1),
          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.patient.contact_number), 1)
        ]),
        (_ctx.showNhsNumber)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createVNode(_component_BaseIcon, { name: "nhs-logo" }),
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.nhsNumberFormatted), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_NavLink, {
            "data-cy": "nav-patient-details-nav",
            to: {
              name: 'patient-details',
              params: { patientId: _ctx.$route.params.patientId }
            }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('platform.common.details')), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          (_ctx.copdHomeMonitoringProgramId)
            ? _withDirectives((_openBlock(), _createBlock(_component_NavLink, {
                key: 0,
                to: {
              name: 'patient-virtual-ward',
              params: { patientId: _ctx.$route.params.patientId, programId: _ctx.copdHomeMonitoringProgramId }
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('custom.uhb.copd.virtual-ward')), 1)
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_allow, 'copd-home-monitoring:program:read']
              ])
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createBlock(_component_NavLink, {
            "data-cy": "consults-nav",
            to: {
              name: 'patient-consults',
              params: { patientId: _ctx.$route.params.patientId }
            }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('custom.uhb.consult.consults')), 1)
            ]),
            _: 1
          }, 8, ["to"])), [
            [_directive_allow, 'consult:read']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_NavLink, {
            to: {
              name: 'patient-scans',
              params: { patientId: _ctx.$route.params.patientId }
            }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('platform.patient.scans')), 1)
            ]),
            _: 1
          }, 8, ["to"])), [
            [_directive_allow, 'patent-scans:read']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_NavLink, {
            "data-cy": "prescriptions-nav",
            to: {
              name: 'patient-prescriptions',
              params: { patientId: _ctx.$route.params.patientId }
            }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('custom.menicon.prescriptions.prescriptions')), 1)
            ]),
            _: 1
          }, 8, ["to"])), [
            [_directive_allow, 'menicon-prescription:read']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_NavLink, {
            "data-cy": "virtual-doctor-nav",
            to: {
              name: 'virtual-doctor',
              params: { patientId: _ctx.$route.params.patientId }
            }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('custom.menicon.virtual-doctor.title')), 1)
            ]),
            _: 1
          }, 8, ["to"])), [
            [_directive_feature_flagged, _ctx.virtualDoctorFeatureFlag],
            [_directive_allow, 'menicon-virtual-doctor:read']
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _withDirectives((_openBlock(), _createBlock(_component_BasePopover, { "data-cy": "clinical-blocks-nav" }, {
            button: _withCtx(() => [
              _createVNode(_component_NavDropdownButton, null, {
                default: _withCtx(() => [
                  _hoisted_36
                ]),
                _: 1
              })
            ]),
            menu: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clinicalBlocksMenuItems, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (item.type === 'link')
                    ? (_openBlock(), _createBlock(_component_PopoverLink, {
                        key: index,
                        to: { name: item.routeName }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(item.i18nKey)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  (item.type === 'divider')
                    ? (_openBlock(), _createElementBlock("hr", {
                        key: index,
                        class: "border-gray-200"
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]),
            _: 1
          })), [
            [_directive_feature_flagged, _ctx.clinicalBlocksFeatureFlag]
          ])
        ])
      ])
    ]),
    (_ctx.patient.deceased_at)
      ? (_openBlock(), _createBlock(_component_BaseBanner, {
          key: 0,
          color: "gray",
          label: 
        _ctx.$t('custom.uhb.patient.banner-deceased-at', {
          deceasedDate: _ctx.formatDate(_ctx.patient.deceased_at, 'long')
        })
      
        }, null, 8, ["label"]))
      : _createCommentVNode("", true)
  ]))
}